import { render, staticRenderFns } from "./order-details.vue?vue&type=template&id=9b279d0c&scoped=true&"
import script from "./order-details.vue?vue&type=script&lang=js&"
export * from "./order-details.vue?vue&type=script&lang=js&"
import style0 from "./order-details.vue?vue&type=style&index=0&id=9b279d0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b279d0c",
  null
  
)

export default component.exports